<line [type]="5" [absoluteContainer]="false"></line>
<div class="footer__wrapper">
  <div class="footer__content">
    @if (footerData?.first; as columnData) {
      <div class="footer__column">
        <h2 class="footer__column-title">{{'footer.contact' | translate}}</h2>
        <div class="footer__column-contents">
          <div
            class="footer__contact-contents"
            [innerHTML]="columnData.textarea"
          ></div>
          <a
            class="footer__email-link"
            [href]="'mailto:' + columnData?.email"
            data-test-id="footer-email-link"
            >{{columnData?.email}}</a
            >
            <div>
              <span>{{columnData?.phone}}</span>
              <span>&nbsp;{{columnData?.open_times}}</span>
            </div>
          </div>
        </div>
      }
      @if (footerLinks(); as links) {
        <div class="footer__column">
          <h2 class="footer__column-title">{{'footer.other' | translate}}</h2>
          <div class="footer__column-contents">
            @for (link of links; track link) {
              @if (link?.routed === 'false') {
                <a
                  [href]="link?.link"
                  target="_blank"
                  rel="noreferrer"
                  [attr.data-test-id]="'footer-link-' + (link?.link | slugify)"
                  >
                  {{link?.title}}
                </a>
              }
              @if (link?.routed === 'true') {
                <a
                  [routerLink]="link?.link"
                  [attr.data-test-id]="'footer-link-' + (link?.link | slugify)"
                  >
                  {{link?.title}}
                </a>
              }
            }
          </div>
        </div>
      }
      <div class="footer__column">
        @if (footerData?.third?.length) {
          <h2 class="footer__column-title">
            {{'footer.socials' | translate}}</h2
            >
          }
          <div class="footer__column-contents">
            @if (footerData?.third?.length) {
              <div class="footer__socials">
                @for (social of footerData?.third; track social) {
                  <a
                    [href]="social?.url"
                    [attr.data-test-id]="'footer-social-link-' + social?.label"
                    [attr.aria-label]="('footer.social_aria.' + social?.label) | translate"
                    target="_blank"
                    rel="noreferrer"
                    >
                    <icon [glyph]="social?.icon"></icon>
                  </a>
                }
              </div>
            }
            <div class="footer__info">
              <div>{{'frontpage.version' | translate}}&nbsp;{{version}}</div>
              <div innerHtml="{{ 'sidemenu.support_text' | translate }}"></div>
            </div>
          </div>
        </div>
      </div>
      @if (footerService?.logoTemplate?.()?.template) {
        <ng-container
          [ngTemplateOutlet]="footerService?.logoTemplate?.()?.template"
          [ngTemplateOutletContext]="{inViewport}"
        ></ng-container>
      }
    </div>
